/**
 * Classification lists for request filter popups.
 * Active-only by default; pass includeDeleted=true to load soft-deleted items too.
 */
export const CLASSIFICATION_FILTER_STORAGE_KEY = 'wsata_filter_include_deleted_classifications';

export function buildClassificationFilterUrl(typeOfClassification, includeDeleted = false) {
  const base = `/agent/Request/Classification?type_of_classification=${typeOfClassification}`;
  return includeDeleted ? `${base}&include_deleted=1` : base;
}

/**
 * Map API classification rows for filter SelectInput (marks deleted items when present).
 * Mutates the array in place — callers assign payload then call requestClass(data).
 */
export function mapClassificationsForFilter(items) {
  if (!Array.isArray(items)) {
    return [];
  }

  items.forEach((item) => {
    const isDeleted = Boolean(item.is_deleted);
    item.color = isDeleted ? 'red' : (item.color || 'red');
    item.text = isDeleted ? `${item.value} (محذوف)` : item.value;
  });

  return items;
}

export function readIncludeDeletedClassificationsPreference() {
  if (typeof localStorage === 'undefined') {
    return false;
  }
  return localStorage.getItem(CLASSIFICATION_FILTER_STORAGE_KEY) === '1';
}

export function persistIncludeDeletedClassificationsPreference(includeDeleted) {
  if (typeof localStorage === 'undefined') {
    return;
  }
  localStorage.setItem(CLASSIFICATION_FILTER_STORAGE_KEY, includeDeleted ? '1' : '0');
}
